import React, { useEffect } from "react";
import "./Solution2.css";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import hpv1 from "../../assest/solutions/hpes1.jpg";
import hpv2 from "../../assest/solutions/hpes2.jpg";
import hpv3 from "../../assest/solutions/hpes3.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Virtualization = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HelmetProvider>
        <div>
          <Helmet>
            {/* Google tag (gtag.js) */}
            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=AW-17221532514"
            ></script>
            <script>
              {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17221532514');
          `}
            </script>
          </Helmet>
        </div>
      </HelmetProvider>

      <Header />
      <div className="resilience-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div class="backup-container">
              <a href="/solutions#Infrastructure" class="backup-text">
                Solution
              </a>
              <p class="backup-text">/HPE Morpheus VM Essentials Software​​​</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">
                      HPE Morpheus VM Essentials Software​
                    </span>
                  </h1>
                  <p className="hero-subtitle"></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="main-content">
          <div className="introduction-text">
            <b>
              เปลี่ยนมุมมอง HPE Morpheus VM Essentials Software
              ตัวเลือกใหม่ที่พร้อมใช้งานจริงในองค์กรคุณ
            </b>
            <br />
            <b>
              ในยุคที่ IT Infrastructure ต้องตอบโจทย์มากกว่าคำว่า "เสถียร"
            </b>{" "}
            <b>องค์กรชั้นนำกำลังมองหาระบบ Virtualization ที่</b>
            <ul>
              <li>ยืดหยุ่น ควบคุมง่าย</li>
              <li>
                ผสานกับ DevOps ได้ทันที และที่สำคัญ... พร้อมเติบโตไปกับธุรกิจ
              </li>
            </ul>
            <b>นี่คือที่มาของ HPE Virtual Machine Environment (VME)</b>
            <p>
              แพลตฟอร์ม Virtualization ระดับ Enterprise
              แต่ราคาเป็นมิตรกับทุกคนที่ออกแบบโดย HPE เพื่อให้คุณ บริหาร Virtual
              Infrastructure ได้ครบวงจร บนสถาปัตยกรรมที่คุณไว้ใจ
            </p>
          </div>
          <div className="image-row">
            <img
              src={hpv1}
              alt="HPE Morpheus VM Essentials Software​​​"
              className="content-image"
            />
            <img
              src={hpv2}
              alt="HPE Morpheus VM Essentials Software​​​"
              className="content-image"
            />
            <img
              src={hpv3}
              alt="HPE Morpheus VM Essentials Software​​​"
              className="content-image"
            />
          </div>

          <h2 className="section-title">
            <b>HPE VME – Virtualization ที่เกิดมาเพื่อองค์กรยุค Hybrid Cloud</b>
          </h2>
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              • สร้างบนเทคโนโลยี Open Source (KVM) – เสถียร ปลอดภัย ยืดหยุ่น
            </p>
            <p className="boost-productivity-text">
              • บริหาร VM และ Container ได้จากศูนย์กลาง – ผ่าน Web Console และ
              REST API
            </p>
            <p className="boost-productivity-text">
              • รองรับการบริหาร VM แบบรวมศูนย์ ผ่าน HPE Morpheus
            </p>
            <p className="boost-productivity-text">
              • ความปลอดภัยระดับองค์กร – รองรับ Secure Boot, TPM และเชื่อมต่อกับ
              iLO ได้เมื่อใช้กับ HPE Server
            </p>
            <p className="boost-productivity-text">
              • รองรับการใช้งานกับ DevOps Tools เช่น Ansible, Terraform, Jenkins
              โดยไม่ต้องลง agent เพิ่ม
            </p>
            <p className="boost-productivity-text">
              • สามารถติดตั้งได้ง่ายไม่ยุ่งยาก– พร้อมใช้งานได้ในองค์กรทันที
            </p>
            <p className="boost-productivity-text">
              • ใช้งานได้ทั้งแบบ Online และ Offline
            </p>
          </div>

          <h2 className="section-title">
            <b>✅ HPE VME เหมาะกับใคร?</b>
          </h2>
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              • องค์กรที่ใช้ HPE หรือ Server ยี่ห้ออื่น และต้องการระบบ
              Virtualization ที่เสถียร
            </p>
            <p className="boost-productivity-text">
              • ทีม IT ที่ต้องการควบคุม VM ได้จากศูนย์กลาง
              โดยไม่ต้องพึ่งโซลูชันแบบ Cloud
            </p>
            <p className="boost-productivity-text">
              • DevOps ที่ต้องการ Platform ที่เชื่อมกับเครื่องมือ Automation
              ได้ทันที
            </p>
            <p className="boost-productivity-text">
              • ธุรกิจที่ต้องการลงทุนแบบคุ้มค่า ด้วย License ที่ไม่ผูกติดกับ
              Cloud รายเดือน
            </p>
          </div>

          <h2 className="section-title">
            <b>🧠 ทำไมเลือก HPE VME?</b>
          </h2>
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              • พัฒนาโดย HPE เพื่อตอบโจทย์ลูกค้าองค์กร (Enterprise Solution)
              โดยเฉพาะ
            </p>
            <p className="boost-productivity-text">
              • ค่าค่าใช้เป็นแบบ CPU (Socket) ไม่ต้องคิดจำนวน Core ให้ยุ่งยาก
            </p>
            <p className="boost-productivity-text">
              • รองรับการทำงานทั้ง VM และ Container – พร้อมรองรับอนาคตของ Hybrid
              Infrastructure
            </p>
            <p className="boost-productivity-text">
              • ใช้งานง่าย พร้อมเอกสารครบสำหรับ Developer และผู้ดูแลระบบ
            </p>
          </div>

          <h2 className="section-title">
            พร้อมก้าวต่อไปกับระบบ Virtualization ที่คุณควบคุมได้เอง
          </h2>
          <div className="boost-productivity-container">
            <p className="boost-productivity-text">
              <b>ไม่ว่าคุณจะเริ่มต้น หรือกำลังวางแผนขยาย</b>{" "}
              <b>HPE VME คือรากฐานที่มั่นคง พร้อมเติบโตไปกับคุณ</b>
            </p>
            <p className="boost-productivity-text">
              <b>สนใจทดลองใช้ หรือต้องการดู Demo?</b>{" "}
              <b>ติดต่อทีมงานได้เลย — พร้อมช่วยคุณเริ่มต้นอย่างมั่นใจ</b>
            </p>
          </div>
        </div>

        <div class="button-container">
          <a
            href="/contactus?subject=HPE Morpheus VM Essentials Software"
            class="contact-button"
          >
            Contact Us
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Virtualization;
